var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadDamaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0047 12.3801C11.0047 12.3801 11.75 12.9998 11.75 13.3801C11.75 14.3809 11.75 16.4998 11.75 16.4998C11.75 16.914 11.4142 16.2498 11 16.2498C10.5858 16.2498 10.25 16.914 10.25 16.4998V13.3801C10.25 13.0197 11.0047 12.3801 11.0047 12.3801Z",
    fill: "#2B323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.1498C6.75 12.9216 6.5054 12.777 6.30547 12.8869L5.40547 13.3817C5.30958 13.4344 5.25 13.5352 5.25 13.6446V20.9998C5.25 21.414 5.58579 21.7498 6 21.7498C6.41421 21.7498 6.75 21.414 6.75 20.9998V13.1498Z",
    fill: "#2B323B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 13.6564C15.25 13.547 15.3096 13.4462 15.4055 13.3935L16.3055 12.8987C16.5054 12.7888 16.75 12.9334 16.75 13.1616V20.9998C16.75 21.414 16.4142 21.7498 16 21.7498C15.5858 21.7498 15.25 21.414 15.25 20.9998V13.6564Z",
    fill: "#2B323B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.7498C11 18.7498 11.75 19.0856 11.75 19.4998V20.9998C11.75 21.414 11.4142 20.7498 11 20.7498C10.5858 20.7498 10.25 21.414 10.25 20.9998V19.4998C10.25 19.0856 11 18.7498 11 18.7498Z",
    fill: "#2B323B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5763 4.02968C5.52799 3.63618 5.15554 3.35812 4.74441 3.4086C4.33328 3.45908 4.03917 3.81899 4.08748 4.21248L5.0349 11.9286C5.06241 12.1526 5.3182 12.2672 5.50368 12.1385L6.33925 11.5587C6.43077 11.4952 6.47958 11.3863 6.466 11.2757L5.5763 4.02968Z",
    fill: "#2B323B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3928 10.0682C16.4064 10.1788 16.3576 10.2877 16.2661 10.3513L15.4305 10.931C15.245 11.0597 14.9892 10.9451 14.9617 10.7211L14.0129 2.99379C13.9646 2.60029 14.2587 2.24038 14.6699 2.1899C15.081 2.13942 15.4534 2.41749 15.5018 2.81098L16.3928 10.0682Z",
    fill: "#2B323B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.539 3.42033C10.4907 3.02684 9.70714 2.79925 9.70714 2.79925C9.70714 2.79925 9.0019 3.20964 9.05021 3.60313L9.22518 5.02809C9.27349 5.42159 9.5293 4.74968 9.94042 4.6992C10.3516 4.64872 10.7623 5.23878 10.714 4.84529L10.539 3.42033Z",
    fill: "#2B323B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.232 7.07413C10.232 7.07413 11.0156 7.30172 11.0639 7.69521L11.4138 10.5451C11.4622 10.9386 11.0514 10.3486 10.6403 10.399C10.2292 10.4495 9.97334 11.1214 9.92503 10.7279L9.5751 7.87802C9.52679 7.48452 10.232 7.07413 10.232 7.07413Z",
    fill: "#2B323B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 9.86863,
    x2: 19.8686,
    y2: 9,
    stroke: "#2B323B",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.8687L21 13.5",
    stroke: "#2B323B",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadDamaged);
export default __webpack_public_path__ + "static/media/road-damaged.c3c29bf46037bf195b76664ad7a25c8c.svg";
export { ForwardRef as ReactComponent };